import { render, staticRenderFns } from "./Kirvano.vue?vue&type=template&id=3815e414&"
import script from "./Kirvano.vue?vue&type=script&lang=js&"
export * from "./Kirvano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports